var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.convo.open_applicants)?_c('vue-dropzone',{ref:"myVueDropzone",attrs:{"id":"dropzone","options":_vm.options},on:{"change":function($event){return _vm.submitAnswer($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }